import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { UserFragmentDoc } from '../../../../../../../graphql/fragments/generated/User';
import { SkillDetailsFragmentDoc } from '../../../../../../skill-matrix/graphql/fragment/generated/SkillDetails';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UserPraiseSkillsQueryVariables = Types.Exact<{
  filters: Types.UsersFilters;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
}>;


export type UserPraiseSkillsQuery = { users: { totalCount: number, edges?: Array<{ node: { id: string, name?: string | null, firstName?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string, skills?: Array<{ __typename: 'SkillType', id: string, name: string, description?: string | null, type: Types.SkillTypeEnum, systemGenerated?: boolean | null, scaleConfig?: { maxScore: number, minScore: number, scaleType: Types.ScaleConfigEnum } | null, rubrics: Array<{ label: string, score?: number | null, description?: string | null, maxScore?: number | null, minScore?: number | null }>, iconSettings?: { value: string, type: Types.IconTypeEnum, iconColor?: string | null } | null }> | null } | null } }> | null, pageInfo?: { hasNextPage?: boolean | null, endCursor?: string | null } | null } };

export type UserPraiseSkillsFragment = { id: string, name?: string | null, firstName?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string, skills?: Array<{ __typename: 'SkillType', id: string, name: string, description?: string | null, type: Types.SkillTypeEnum, systemGenerated?: boolean | null, scaleConfig?: { maxScore: number, minScore: number, scaleType: Types.ScaleConfigEnum } | null, rubrics: Array<{ label: string, score?: number | null, description?: string | null, maxScore?: number | null, minScore?: number | null }>, iconSettings?: { value: string, type: Types.IconTypeEnum, iconColor?: string | null } | null }> | null } | null };


export type UserPraiseSkillsFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const UserPraiseSkillsFragmentDoc = /*#__PURE__*/ gql`
    fragment UserPraiseSkills on UserType {
  ...User
  orgRole {
    id
    name
    skills {
      ...SkillDetails
    }
  }
}
    `;
export const UserPraiseSkillsDocument = /*#__PURE__*/ gql`
    query userPraiseSkills($filters: UsersFilters!, $first: Float) {
  users(filters: $filters, first: $first) {
    edges {
      node {
        ...UserPraiseSkills
      }
    }
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${UserPraiseSkillsFragmentDoc}
${UserFragmentDoc}
${SkillDetailsFragmentDoc}`;

export function useUserPraiseSkillsQuery(options: Omit<Urql.UseQueryArgs<UserPraiseSkillsQueryVariables>, 'query'>) {
  return Urql.useQuery<UserPraiseSkillsQuery, UserPraiseSkillsQueryVariables>({ query: UserPraiseSkillsDocument, ...options });
};